/* eslint-disable no-console */
import { useLayoutEffect, useState } from 'react';
import { deprecatedMsg } from './deprecatedMsg.js';

const noop = () => {};

export const useWindowSize = () => {
  console.warn(`useWindowSize ${deprecatedMsg}`);
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    if (!window) return noop;
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    window.addEventListener('orientationchange', updateSize);
    updateSize();
    return () => {
      window.removeEventListener('resize', updateSize);
      window.removeEventListener('orientationchange', updateSize);
    };
  }, []);
  if (!window) return noop;
  return size;
};

export default useWindowSize;
